import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet'; // Import react-helmet
import PsychiatricImg from '../img/Counseling3.webp'; // Replace with the relevant image for psychiatric cases

const Adult_Psychiatric_Cases = () => {
    const cardData = [
        {
            id: 1,
            title: 'Major Depressive Disorder',
            text: 'Major depressive disorder is a mood disorder that causes persistent feelings of sadness and loss of interest in activities. Individuals with MDD may experience low energy, changes in appetite, difficulty concentrating, and thoughts of death or suicide. Treatment typically includes antidepressant medications .',
        },
        {
            id: 2,
            title: 'Bipolar Disorder',
            text: 'Bipolar disorder is characterized by extreme mood swings, including periods of intense depression and elevated mood (mania or hypomania). During manic episodes, individuals may experience increased energy, impulsive behavior, and reckless decisions. Treatment often involves mood stabilizers and psychotherapy.',
        },
        {
            id: 3,
            title: 'Schizophrenia',
            text: 'Schizophrenia is a severe mental disorder that affects thinking and behavior. Individuals may experience hallucinations, delusions, disorganized thinking, and reduced ability to function normally. Schizophrenia is typically treated with antipsychotic medications.',
        },
        {
            id: 4,
            title: 'Anxiety Disorders',
            text: 'Anxiety disorders, such as generalized anxiety disorder, panic disorder, and social anxiety disorder, involve excessive worry, fear, and physical symptoms like rapid heartbeat and sweating. Treatment includes cognitive-behavioral therapy, relaxation techniques.',
        },
        {
            id: 5,
            title: 'Obsessive-Compulsive Disorder',
            text: 'Obsessive-compulsive disorder is characterized by unwanted, intrusive thoughts (obsessions) and repetitive behaviors (compulsions) performed to reduce anxiety. Treatment includes CBT, particularly exposure and response prevention, and selective serotonin reuptake inhibitors (SSRIs).',
        },
        {
            id: 6,
            title: 'Post-Traumatic Stress Disorder',
            text: 'Post-traumatic stress disorder can develop after experiencing  traumatic event. Symptoms include  severe anxiety, and emotional numbness. PTSD treatment often involves trauma-focused CBT and eye movement desensitization and reprocessing (EMDR), along with medications.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>Adult Psychiatric Cases - Understanding Mental Health Disorders</title>
                <meta
                    name="description"
                    content="Explore the different types of adult psychiatric disorders, including major depressive disorder, bipolar disorder, schizophrenia, anxiety disorders, OCD, and PTSD. Learn about symptoms, treatments, and recovery."
                />
                <meta
                    name="keywords"
                    content="adult psychiatric disorders, major depressive disorder, bipolar disorder, schizophrenia, anxiety disorders, obsessive-compulsive disorder, PTSD, mental health"
                />
                <meta name="author" content="Your Organization Name" />
                <meta property="og:title" content="Adult Psychiatric Cases - Understanding Mental Health Disorders" />
                <meta
                    property="og:description"
                    content="Explore the different types of adult psychiatric disorders, including major depressive disorder, bipolar disorder, schizophrenia, anxiety disorders, OCD, and PTSD. Learn about symptoms, treatments, and recovery."
                />
                <meta property="og:image" content={PsychiatricImg} />
                <meta property="og:url" content="http://www.yoursite.com/adult-psychiatric-cases" />
                <meta name="twitter:title" content="Adult Psychiatric Cases - Understanding Mental Health Disorders" />
                <meta name="twitter:description" content="Explore the different types of adult psychiatric disorders, including major depressive disorder, bipolar disorder, schizophrenia, anxiety disorders, OCD, and PTSD." />
                <meta name="twitter:image" content={PsychiatricImg} />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className="mb-5">
                        <img    
                            src={PsychiatricImg}
                            alt="Psychiatric counseling image"
                            className="img-fluid h-100 w-100 rounded-md"
                        />
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className="mb-5">
                        <h1 style={{ fontFamily: 'monospace' }} className="mb-4">
                            Adult Psychiatric Cases
                        </h1>
                        <p style={{ fontSize: '20px', fontFamily: 'initial' }}>
                            Adult psychiatric disorders encompass a range of mental health conditions that can affect an individual's thoughts, feelings, and behavior. These conditions can interfere with daily life and functioning. Early diagnosis and treatment are key to managing and improving outcomes for those affected.
                        </p>
                        <p style={{ fontSize: '20px', fontFamily: 'initial' }}>
                            From mood disorders to psychotic conditions, psychiatric disorders in adults require careful attention and treatment, including therapy, medication, and support to foster recovery and well-being.
                        </p>
                    </Col>
                </Row>
            </Container>

            <Container className="mb-5">
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className="bg-info-subtle">
                                <Card.Body>
                                    <Card.Title style={{ color: '#093c60' }} className="fw-bold">
                                        {card.title}
                                    </Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default Adult_Psychiatric_Cases;
